import Box from '@material-ui/core/Box'
import { makeStyles, styled } from '@material-ui/styles'

// const lightGrey = '#d6d6d6'
const mobile = 500

export const AddableSectionWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginTop: theme.spacing(2),
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(4),
  paddingLeft: theme.spacing(4),
  border: `solid 1px ${theme.palette.grey[400]}`,
  borderLeft: `4px solid ${theme.palette.primary.main}`,

  '& .inputDeleteWrapper': {
    display: 'flex',
  },
  [theme.breakpoints.down(mobile)]: {
    flexDirection: 'column',
    padding: theme.spacing(1),
    '& button': {
      alignSelf: 'flex-end',
    },
  },
}))

export const InnerAddable = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 'auto',
  marginRight: theme.spacing(2),
}))

const useStyles = makeStyles(theme => ({
  textFields: {
    marginBottom: theme.spacing(4),
  },
}))

export default useStyles
